import { Link, useNavigate } from "react-router-dom";
import React, { useState } from "react";
import "../../assets/css/--component-login.css";
import logo from "../../assets/images/mains-logo.png";
import leftSign from "../../assets/images/left.png";
import emailLogo from "../../assets/images/email-sent.png";
import { forgotPassword } from "../../helper/backend-methods";

function ForgetPassword(props) {
  const history = useNavigate();
  const [loading, setLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [values, setValues] = useState({
    commonField: "",
    locked: false,
  });
  const [errors, setErrors] = useState({ commonField: "", serverError: "" });

  const validateSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    let flag = false;
    let type = "email";
    const err = { commonField: "", serverError: "" };
    const emailRegex = /^\w+([\.-]?\w+)*(\+\w+)?@\w+([\.-]?\w+)*(\.\w{2,10})+$/;
    if (!values || !values.commonField || values.commonField < 6) {
      err.commonField = "This field is required";
      flag = true;
    } else {
      if (!isNaN(values.commonField)) {
        if (
          !values.commonField ||
          values.commonField.replaceAll(/\s/g, "").length < 9 ||
          values.commonField.replaceAll(/\s/g, "").length > 12 ||
          !values.commonField.startsWith("966")
        ) {
          err.commonField = "Please provide a valid phone number";
          flag = true;
        }
        type = "phone";
      } else if (!emailRegex.test(values.commonField)) {
        err.commonField = "Please provide a valid email address";
        flag = true;
      }
    }
    setErrors(err);
    if (!flag) {
      forgotPassword({ email: values.commonField })
        .then(({ data }) => {
          if (data.Status) {
            if (type === "email") {
              setErrors({
                commonField: "",
                serverError: `We've sent an email to ${values.commonField} with instructions to reset your password.`,
              });
              setIsSuccess(true);
              setValues((prev) => ({ ...prev, locked: true }));
            }
          } else {
            if (data.StatusCode === 2021) {
              setValues((prev) => ({ ...prev, locked: true }));
              setErrors({
                commonField: "",
                serverError:
                  "Your account has been locked because too many attempts were made. Please contact support@Main Country Grill and Store.com for assistance.",
              });
            } else {
              setErrors({
                commonField: "",
                serverError: type === "email" ? "No account found with this email address" : "No account found with this phone number",
              });
            }
            setIsSuccess(false);
          }
          setLoading(false);
        })
        .catch((e) => {
          setErrors({
            commonField: "",
            serverError: type === "email" ? "No account found with this email address" : "No account found with this phone number",
          });
          setLoading(false);
          setIsSuccess(false);
        });
    } else {
      setLoading(false);
    }
  };

  return (
    <section id="login" className="forgot-reset-password">
      <div className="wrapper" style={{ width: "100%" }}>
        <div className="logo-img text-center mb-5 w-100">
          <img src={logo} alt="Main Country Grill and Store" className="form-logo" />
        </div>
        <div className="login-form-wrapper">
          {!values.locked ? (
            <form onSubmit={validateSubmit}>
              <h1 className="form-title text-center fs-30">Forgot Password?</h1>
              <p className="form-description text-center text-gray-600">
                We will send you an email with instructions on how to reset your password.
              </p>
              {errors.serverError ? (
                <p className="text-left txt-danger fs-16 fw-400">
                  <i className="ri-error-warning-line"></i> {errors.serverError}
                </p>
              ) : null}
              <div className="form-group has-icon">
                <label htmlFor="commonField">
                  Enter Your Email<span className="txt-danger">*</span>
                </label>
                <input
                  id="commonField"
                  readOnly={isSuccess}
                  type="text"
                  name="commonField"
                  onChange={(e) => {
                    setValues((prev) => ({ ...prev, commonField: e.target.value.replaceAll(/\s/g, "").slice(0, 50) }));
                  }}
                  value={values.commonField}
                  placeholder="Enter Email Address"
                  className={`${errors.commonField || errors.serverError ? "bd-danger" : ""}`}
                />
                {errors.commonField || errors.serverError ? (
                  <button type="button">
                    <i className="ri-error-warning-line txt-danger fw-400"></i>
                  </button>
                ) : null}
                {errors.commonField ? <span className="txt-danger fs-12 fw-400">{errors.commonField}</span> : null}
              </div>
              {!isSuccess ? (
                <div className="form-group">
                  <button type="submit" disabled={loading} className="btn btn-primary w-100 rounded-5 border-0 mt-3">
                    {loading ? "Please Wait..." : "GET PASSWORD RESET LINK"}
                  </button>
                </div>
              ) : null}
              <div className="form-group mb-0 fs-16 text-gray-600 mt-4">
                <Link
                  to={"/login"}
                  className="fs-14 ml-2 text-grey d-flex align-items-center justify-content-center text-decoration-none text-gray-600"
                >
                  <img src={leftSign} alt="" /> Back To Login
                </Link>
              </div>
            </form>
          ) : (
            <form>
              <img src={emailLogo} alt="EmailLogo" className="form-logo" />
              <h1 className="form-title text-center fs-30 fw-500 mb-3 font-inter">Email Sent</h1>
              <p className="text-center text-gray-600 fs-18">
                An email with password reset instructions has been sent to your inbox. If it doesn't appear, please check your spam or junk
                folder.
              </p>
              <p className="text-center text-gray-600 fs-18">
                If you no longer have access to this email account, please contact us at{" "}
                <a href="mailto: support@mainscountry.com" className="link">
                  support@mainscountry.com
                </a>
              </p>
            </form>
          )}
        </div>
      </div>
    </section>
  );
}
export default ForgetPassword;
